import { Formik } from "formik";
import Eye from "../../form/Eye";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../form/ErrorMessage";
import { signInSchema } from "../../../utils/schema";
import { authSignin } from "../../../redux/features/coach/actions/authAction";
import { handlePostLoginFlow } from "../../../utils/postLoginFlow";

const CoachLogin = ({ onSignUp, onClose, onForgot }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isEye, setIsEye] = useState(false);
  // const { isLoading } = useSelector((state) => state.coach.auth);

  const initialValues = {
    email: "",
    password: "",
  };

  const handleLogin = (values) => {
    const callback = (response) => {
      if (response.success) {
        handlePostLoginFlow({ response, dispatch, navigate, onClose });
      }
    };
    dispatch(authSignin({ payload: values, callback }));
  };

  return (
    <div
      className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-0 p-0 pb-2">
            <button
              type="button"
              class="btn-close ct_close_position_right12"
              onClick={onClose}
            ></button>
          </div>
          <div class="modal-body pe-0">
            <section class="ct_signup_main py-3">
              <div class="container-fluid">
                <div class="row align-items-center">
                  <div class="col-xxl-4 col-xl-5 col-lg-5 mb-4 mb-lg-0 d-none d-lg-block">
                    <div class="ct_signup_left_img">
                      <img src="../assets/img/login_coach.png" alt="" />
                    </div>
                  </div>
                  <div class="col-xxl-8 col-xl-7 col-lg-7 mb-4 mb-lg-0 mx-auto pe-0">
                    <div class="ct_signup_right_content px-3 ct_custom_scroll">
                      <div class="ct_signup_logo mb-3">
                        <img src="../assets/img/Nuvio_logo.png" alt="" />
                      </div>
                      <div class="mt-0 text-center">
                        <h2 class="ct_fs_32  mb-0 ct_darkblue_text">
                          Welcome Back!
                        </h2>
                      </div>
                      <Formik
                        initialValues={initialValues}
                        validationSchema={signInSchema}
                        onSubmit={(values, actions) => {
                          handleLogin(values);
                        }}
                      >
                        {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          setFieldValue,
                        }) => (
                          <form onSubmit={handleSubmit} class="mt-5">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="form-group mb-4">
                                  <label
                                    for=""
                                    class="mb-2 d-block ct_darkblue_text"
                                  >
                                    Email
                                  </label>
                                  <input
                                    type="text"
                                    class="form-control ct_input"
                                    placeholder="Email"
                                    id="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.email}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="email"
                                  />
                                </div>
                              </div>
                             
                              <div class="col-md-12">
                                <div class="form-group mb-3">
                                  <label
                                    for=""
                                    class="mb-2 d-block ct_darkblue_text"
                                  >
                                    Password
                                  </label>
                                  <div class="position-relative">
                                    <input
                                      type={isEye ? "text" : "password"}
                                      id="password"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values?.password}
                                      class="form-control ct_input pe-5"
                                      placeholder="Password"
                                    />
                                    {/* <i class="fa-solid fa-eye ct_show_eye"></i> */}
                                    <Eye
                                      isEye={isEye}
                                      onClick={() => setIsEye(!isEye)}
                                    />
                                  </div>
                                  <ErrorMessage
                                    errors={errors}
                                    touched={touched}
                                    fieldName="password"
                                  />
                                </div>
                              </div>
                              <div class="text-end">
                                <a onClick={onForgot} class="ct_yellow_text">
                                  Forgot Password?
                                </a>
                              </div>
                            </div>

                            <div class="text-center mt-4">
                              <a
                                class="ct_yellow_btn w-75 mx-auto"
                                onClick={handleSubmit}
                              >
                                Log In
                              </a>
                            </div>
                          </form>
                        )}
                      </Formik>
                      <div class=" text-center mt-3 ct_darkblue_text">
                        Don’t have an account?{" "}
                        <a class="ct_orange_text" onClick={onSignUp}>
                          {" "}
                          Sign Up
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachLogin;
